export const GET_TRANSLATIONS = 'get.translations';

export type ServiceTranslationsQueries = {
    [GET_TRANSLATIONS]: string[];
};
export type ServiceTranslationsQueriesResponseType = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [GET_TRANSLATIONS]: Promise<{ [key: string]: any }>;
};
